import request from './AxiosRequest';

const browse = (data) =>
	request({
		url: `/Services/ListingService.svc/json/SearchListing`,
		method: 'POST',
		data: { "criteria": data }
	});

const searchListingService = (data) =>
	request({
		url: `/Services/ListingService.svc/json/SearchListingService`,
		method: 'POST',
		data: { "criteria": data }
	});

const SearchListing = {
	browse,
	searchListingService
}

export default SearchListing;
